"use client"

import { FC } from "react"
import DefaultPlacements from "./DefaultPlacements"
import { useAppSelector } from "@/lib/redux/hooks"
import { Button, Col, Row } from "antd"
import { useToursCategories } from "@/hooks/tour/useToursCategories"
import MarkIcon from "@/components/icons/MarkIcon"
import Text from "@/components/common/Typography/Text"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFlag } from "@fortawesome/free-regular-svg-icons"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"

type SearchPlacementsResultProps = {
  type?: 'destination' | 'departure',
  onChange?: (valueObject?: any) => void,
}

const SearchPlacementsResult: FC<SearchPlacementsResultProps> = ({ type, onChange }) => {
  const searchValue = useAppSelector(state => state.tour.searchingDestinationsValue)
  const { data: { searchDestinationsResult, searchToursResult, searchDeparturesResult } } = useToursCategories()
  const isDesktop = useIsDesktop()

  if (type === 'departure') {
    return (
      <Row gutter={[10, 10]} style={isDesktop ? { padding: 10 }: {}}>
        {searchDeparturesResult.map(des => {
          return (
            <Col span={24}>
              <Button
                onClick={() => onChange && onChange(des)}
                size='large'
                type='text'
                block
                style={{ textAlign: 'start', justifyContent: 'start', whiteSpace: 'wrap' }}
              >
                {des.name}
              </Button>
            </Col>
          )
        })}
      </Row>
    )
  }

  if (!!searchValue) {
    return (
      <Row gutter={[10, 10]} style={isDesktop ? { padding: 10 }: {}}>
        {/* {(type === 'destination' ? searchDestinationsResult : searchDeparturesResult).map(des => {
          return (
            <Col span={24}>
              <Button
                size='large'
                type='text'
                style={{
                  justifyContent: 'space-between'
                }}
                block
              >
                <Row style={{ width: '100%' }} justify='space-between' align='middle'>
                  <Col>
                    <MarkIcon /> {des.name} - {des.country}
                  </Col>
                  <Col>
                    <Text strong>
                      {des.tourCount} Tours
                    </Text>
                  </Col>
                </Row>
              </Button>
            </Col>
          )
        })} */}
        {searchToursResult.map(tour => {
          return (
            <Col span={24}>
              <Button
                onClick={() => onChange && onChange(tour)}
                size='large'
                type='text'
                style={{
                  justifyContent: 'space-between',
                  textAlign: 'start', whiteSpace: 'wrap',
                  height: 'auto',
                  maxHeight: 'unset'
                }}
                block
              >
                <Row style={{ width: '100%' }} justify='space-between' align='middle'>
                  <Col>
                    <FontAwesomeIcon icon={faFlag} /> {tour.name}
                  </Col>
                  <Col>
                    {/* <Text strong>
                      {des.tourCount} Tours
                    </Text> */}
                  </Col>
                </Row>
              </Button>
            </Col>
          )
        })}
      </Row>
    )
  }
  return (
    <DefaultPlacements onChange={onChange} />
  )
}

export default SearchPlacementsResult